<template>
  <v-skeleton-loader
    type="table"
    :loading="loading"
    width="90%"
    class="mx-auto"
  >
  <v-container>
    <v-card v-if="ufs.length > 0" flat>
      <v-table>
        <thead>
          <tr>
            <th class="font-weight-bold">Código UF</th>
            <th class="font-weight-bold">Sigla</th>
            <th class="font-weight-bold">Nome</th>
          </tr>
        </thead>
        <tbody class="zebra-table">
          <tr v-for="uf in ufs" :key="uf.cod_uf">
            <td>{{ uf.cod_uf }}</td>
            <td>{{ uf.sigla }}</td>
            <td>{{ uf.nome }}</td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
  </v-skeleton-loader>
</template>

<script>
import { mapActions } from "vuex";
import api from "../services/api";

export default {
  data: () => ({
    ufs: [],
    loading: false,
  }),
  mounted() {
    this.getUfs();
  },
  methods: {
    ...mapActions(["triggerFeedback"]),
    async getUfs() {
      this.loading = true;
      try {
        const response = await api.get("/uf/");
        this.ufs = response.data;
      } catch (error) {
        this.triggerFeedback({
          message: "Erro ao buscar UFs!",
          color: "error",
          icon: "mdi-alert-circle",
        });

        console.error(error);
        this.$router.push({ name: 'home' });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.zebra-row {
  background-color: #f5f5f5;
}

.zebra-table tr:hover {
  background-color: #e0e0e0;
}

thead {
  background-color: #e3f0ff; 
  font-size: 20px;
  color: #1976d2;            
}

tbody {
  font-size: 18px;
  background-color: #fafdff; 
}

td {
  color: #222;
  background-color: inherit;
  border-bottom: 1px solid #e3e7ed;
}

tr.zebra-row td {
  background-color: #f5faff;
}

tr:hover td {
  background-color: #eaf4ff !important;
}

th, td {
  padding: 12px 10px;
}

.v-table {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(25, 118, 210, 0.06);
}
</style>
